const CURRENCY_CONFIG = {
  // ToC【以字母顺序排列，方便查找】
  de: {
    currencyCode: 'EUR',
    currencySymbol: ' €',
    currencyPosition: 'post',
    currencyFunction: 'dotThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  es: {
    currencyCode: 'EUR',
    currencySymbol: ' €',
    currencyPosition: 'post',
    currencyFunction: 'dotThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  fr: {
    currencyCode: 'EUR',
    currencySymbol: ' €',
    currencyPosition: 'post',
    currencyFunction: 'spaceThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  hk: {
    currencyCode: 'HKD',
    currencySymbol: 'HK$',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'integer',
    currencyBlindPrice: '???',
  },
  id: {
    currencyCode: 'IDR',
    currencySymbol: 'Rp ',
    currencyPosition: 'pre',
    currencyFunction: 'dotThousCommaDec',
    currencyExpect: 'integer',
    currencyBlindPrice: '???',
  },
  in: {
    currencyCode: 'INR',
    currencySymbol: '₹',
    currencyPosition: 'pre',
    currencyFunction: 'spaceHundredsCommaThousCommaDec',
    currencyExpect: 'integer',
    currencyBlindPrice: '???',
  },
  it: {
    currencyCode: 'EUR',
    currencySymbol: ' €',
    currencyPosition: 'post',
    currencyFunction: 'dotThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  nl: {
    currencyCode: 'EUR',
    currencySymbol: '€ ',
    currencyPosition: 'pre', // 荷兰的符号在前面，有别于其他欧元区国家…
    currencyFunction: 'dotThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  ru: {
    currencyCode: 'RUB',
    currencySymbol: ' ₽',
    currencyPosition: 'post',
    currencyFunction: 'spaceThousCommaDec',
    currencyExpect: 'integer',
    currencyBlindPrice: '???',
  },
  tr: {
    currencyCode: 'TRY',
    currencySymbol: 'TL',
    currencyPosition: 'post',
    currencyFunction: 'dotThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  tw: {
    currencyCode: 'TWD',
    currencySymbol: 'NT$',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'integer',
    currencyBlindPrice: '???',
  },
  uk: {
    currencyCode: 'GBP',
    currencySymbol: '£',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  // ToB【以字母顺序排列，方便查找】
  bd: {
    currencyCode: 'BDT',
    currencySymbol: '৳ ',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'integer',
    currencyBlindPrice: '???',
  },
  br: {
    currencyCode: 'BRL',
    currencySymbol: 'R$ ',
    currencyPosition: 'pre',
    currencyFunction: 'dotThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  cl: {
    currencyCode: 'CLP',
    currencySymbol: '$',
    currencyPosition: 'pre',
    currencyFunction: 'dotThousCommaDec',
    currencyExpect: 'integer',
    currencyBlindPrice: '???',
  },
  cz: {
    currencyCode: 'CZK',
    currencySymbol: ' Kč',
    currencyPosition: 'post',
    currencyFunction: 'spaceThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  eg: {
    currencyCode: 'EGP',
    currencySymbol: 'E£',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  gcc: {
    currencyCode: 'AED',
    currencySymbol: 'AED',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  global: {
    currencyCode: 'USD',
    currencySymbol: 'US$',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  gr: {
    currencyCode: 'GRD',
    currencySymbol: '₯',
    currencyPosition: 'post',
    currencyFunction: 'dotThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  jp: {
    currencyCode: 'JPY',
    currencySymbol: '円',
    currencyPosition: 'post',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'integer',
    currencyBlindPrice: '???',
  },
  kr: {
    currencyCode: 'KRW',
    currencySymbol: '₩',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'integer',
    currencyBlindPrice: '???',
  },
  lk: {
    currencyCode: 'LKR',
    currencySymbol: 'රු ',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  ma: {
    currencyCode: 'MAD',
    currencySymbol: 'DH',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  mea: {
    currencyCode: 'USD',
    currencySymbol: 'US$',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  mx: {
    currencyCode: 'MXN',
    currencySymbol: '$',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  my: {
    currencyCode: 'MYR',
    currencySymbol: 'RM ',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  ng: {
    currencyCode: 'NGN',
    currencySymbol: '₦',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  np: {
    currencyCode: 'NPR',
    currencySymbol: 'रू ',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  ph: {
    currencyCode: 'PHP',
    currencySymbol: '₱',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  pk: {
    currencyCode: 'PKR',
    currencySymbol: 'Rs ',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  pl: {
    currencyCode: 'PLN',
    currencySymbol: ' zł',
    currencyPosition: 'post',
    currencyFunction: 'spaceThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  sa: {
    currencyCode: 'SAR',
    currencySymbol: 'SAR',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  se: {
    currencyCode: 'SEK',
    currencySymbol: ' kr',
    currencyPosition: 'post',
    currencyFunction: 'spaceThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  sg: {
    currencyCode: 'SGD',
    currencySymbol: '$',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  th: {
    currencyCode: 'THB',
    currencySymbol: '฿',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  ua: {
    currencyCode: 'UAH',
    currencySymbol: ' грн.',
    currencyPosition: 'post',
    currencyFunction: 'spaceThousCommaDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  vn: {
    currencyCode: 'VND',
    currencySymbol: ' ₫',
    currencyPosition: 'post',
    currencyFunction: 'dotThousCommaDec',
    currencyExpect: 'integer',
    currencyBlindPrice: '???',
  },
  us: {
    currencyCode: 'USD',
    currencySymbol: '$',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  uz: {
    currencyCode: 'UZS',
    currencySymbol: 'UZS',
    currencyPosition: 'post',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  za: {
    currencyCode: 'ZAR',
    currencySymbol: 'R',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
  default: {
    currencyCode: 'USD',
    currencySymbol: 'US$',
    currencyPosition: 'pre',
    currencyFunction: 'commaThousDotDec',
    currencyExpect: 'decimal',
    currencyBlindPrice: '???',
  },
}

/**
 * 获取对应市场的货币配置
 * @param local 市场参数
 */
function getCurrencyConfig(local) {
  return CURRENCY_CONFIG[local] || CURRENCY_CONFIG.default
}

export { CURRENCY_CONFIG, getCurrencyConfig }
